export const SUPPORTED_LAYOUTS = {
  LIST: 'UILayoutList',
  CAROUSEL: 'UILayoutCarousel',
};

export const SUPPORTED_BLOCKS = {
  BANNER: 'UIBanner',
  RESTAURANT: 'UIRestaurant',
  SHORTCUT: 'UIShortcut',
  CARD: 'UICard',
};

export const SUPPORTED_TARGETS = {
  ACTION: 'UITargetAction',
  PARAMS: 'UITargetParams',
  RESTAURANT: 'UITargetRestaurant',
  MENU_ITEM: 'UITargetMenuItem',
};

export const PRELOAD_LIMIT = 25;
